import { render, staticRenderFns } from "./VvFormTextInput.vue?vue&type=template&id=39fcc35c&scoped=true&"
import script from "./VvFormTextInput.vue?vue&type=script&lang=js&"
export * from "./VvFormTextInput.vue?vue&type=script&lang=js&"
import style0 from "./VvFormTextInput.vue?vue&type=style&index=0&id=39fcc35c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fcc35c",
  null
  
)

export default component.exports